<template>
    <div id="newDom2">
        <video
            id="videoPlayer2"
            ref="videoPlayer2"
            class="video-js vjs-big-play-centered"
            width="100%"
            height="100%">
        </video>
    </div>
</template>

<script >
    import 'videojs-flash';
    import '../../assets/js/zh-CN';
    
	export default {
		props:['playParam2'],
	    data() {
		    return {
                player: null, // 播放器
                timer: null,
                videoOptions: {
                    loop: false, // true -- 视频一结束就重新开始
                    fluid: false,
                    controls: true,
                    autoplay: true, // true--浏览器准备好时开始回放
                    height: '360',
                    poster: "", // 封面地址
                    language: 'zh-CN',
                    techOrder: ['flash'],
                    sources: [{
                        type: "rtmp/mp4", // 类型
                        src: this.playParam2.play_url // 视频播放路径
                    }],
                    controlBar: {
                        children: [
                            {name: 'playToggle'}, // 播放按钮
                            {name: 'currentTimeDisplay'}, // 当前已播放时间
                            {name: 'progressControl'}, // 播放进度条
                            {name: 'durationDisplay'}, // 总时间
                            {
                                name: 'volumePanel', // 音量控制
                                inline: false, // 不使用水平方式
                            },
                            {name: 'FullscreenToggle'} // 全屏
                        ]
                    },
                }
			}
		},
		mounted(){
            this.initPlay();
        },
        beforeDestroy() {
            this.player && this.player.dispose();
        },
		methods:{
            /**
             * 播放器初始化
             */
			initPlay(){
                let self = this;
                let videoPlayer = document.getElementById('newDom2');
                videoPlayer.innerHTML = '<video id="videoPlayer2" class="video-js vjs-big-play-centered vjs-fluid" width="100%" height="100%"> </video>'
                this.player = this.$videojs('videoPlayer2', this.videoOptions, function onPlayerReady() {})
                this.player.on('play', function() {
                    self.onPlayerPlay();
                })
                this.player.on('timeupdate', function() {
                    self.onPlayerTimeupdate();
                })
			},
			onPlayerPlay(){
                var normal_currentTime = this.player.currentTime();
                clearTimeout(this.timer);

                this.timer = setTimeout( () => {
                    var unnormal_currentTime = this.player.currentTime();
                    if( normal_currentTime.toString() == unnormal_currentTime.toString() ){
                        this.player.pause();
                        this.player.play();
                    }
                }, 300)
            },
			onPlayerTimeupdate(){       
				if( !is_empty( this.playParam2.end_time ) && !is_empty( this.playParam2.end_time ) ){
					//小于开始时间，从开始时间播放
					if( this.player.currentTime() < this.playParam2.start_time  ){
						setTimeout( () => {
							this.player.currentTime( this.playParam2.start_time ) ;
						},100)
					}
					//大于结束时间，播放停止
					else if( this.player.currentTime() > this.playParam2.end_time ){
						setTimeout( () => {
							this.player.currentTime( this.playParam2.start_time ) ;
							this.player.pause();
						},100)
					}

				}
			},
		}
	}
</script>

<style lang="scss">
#videoPlayer2{
    width: 100%;
}
    @import url('../../assets/css/video.css');
</style>